export const months = [...Array(12).keys()].map(month => ({label: month + 1, value: month + 1}));

export const days = [...Array(31).keys()].map(day => ({label: day + 1, value: day + 1}));